import { atom } from 'jotai';

export type PushyTokenStatus = 'unregistered' | 'registering' | 'registered' | 'failed';

export const pushyTokenAtom = atom<string | null>(null);
export const pushyTokenStatusAtom = atom<PushyTokenStatus>('unregistered');
export const pushyInitializedAtom = atom<boolean>(false);
export const pushyDeviceTokenAtom = atom<string | null>(null);
